import { InputsHeader } from '../InputsHeader';
import { Radio } from '../form-controls';
import { Grid } from '../layout';

export function Crop() {
  const name = 'starterFertilizer.isCornAfterCorn';

  return (
    <>
      <InputsHeader
        title="Planned"
        subtitle="Select Planned Crop"
        name={name}
        required
      />
      <Grid columns={2} columnSpacing={{ xs: 2, sm: 3 }}>
        <Radio label="Corn after Corn" name={name} value={true} />
        <Radio label="Corn after Soy" name={name} value={false} />
      </Grid>
    </>
  );
}
